"use client";

import Image from "next/image";
import { ArrowUpRight } from "@phosphor-icons/react";
import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const IMAGE_SRC =
	"/image/new-version/ValueAddedSolutions/surface-finishing/perfect-your-projects-surface-finish.webp";

export default function SurfaceFinishingProjectCta() {
	const t = useTranslations("new-surface-finishing");

	return (
		<section className="bg-[#f6ffde] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="grid items-center gap-8 lg:grid-cols-[0.95fr_1.05fr] lg:gap-16">
					<div>
						<h2 className="mb-5 text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
							<span className="block">{t("projectCtaTitleLine1")}</span>
							<span className="block">{t("projectCtaTitleLine2")}</span>
						</h2>
						<p className="mb-6 text-sm leading-relaxed text-black md:mb-8 md:text-base">
							{t("projectCtaDesc")}
						</p>
						<Link
							href="/upload"
							className="inline-flex items-center justify-center gap-2 rounded bg-themePrimary400 px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-[#83b751] hover:text-white md:px-8 md:py-3.5 md:text-base"
						>
							{t("projectCtaButton")}
							<ArrowUpRight className="h-5 w-5" weight="bold" aria-hidden="true" />
						</Link>
					</div>

					<div className="relative aspect-[16/9] w-full overflow-hidden bg-white">
						<Image
							src={IMAGE_SRC}
							alt={t("projectCtaImageAlt")}
							fill
							className="object-cover"
							sizes="(max-width: 1024px) 100vw, 52vw"
						/>
					</div>
				</div>
			</div>
		</section>
	);
}
